// src/utils/fetchWithIdToken.js
import { auth } from '../firebase';

/**
 * Fetch utility that automatically includes Firebase ID token in Authorization header
 * @param {string} url - The API endpoint to fetch from
 * @param {object} options - Additional fetch options (method, body, headers, etc.)
 * @returns {Promise} - The parsed JSON response
 */
export const fetchWithIdToken = async (url, options = {}) => {
    const user = auth.currentUser;

    if (!user) {
        throw new Error('User not authenticated');
    }

    // Get the Firebase ID token
    const idToken = await user.getIdToken();

    // Determine the base URL - match the logic from api.js
    const baseURL = process.env.REACT_APP_IS_LOCAL === "true"
        ? "http://localhost:8080"
        : "https://backend.rugbycore.com";
    const fullURL = url.startsWith('http') ? url : `${baseURL}${url}`;

    // Merge headers
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
        ...options.headers
    };

    // Make the fetch request
    const response = await fetch(fullURL, {
        ...options,
        headers
    });

    // Check if response is ok
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
    }

    // Parse and return JSON
    return await response.json();
};
